import React, { Component } from 'react';
import { Tabs, Table } from 'antd';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Panel } from 'components/ui';
import { toTimezone } from 'utils/dateTimeUtils';
import { fetchWorkflowActionLogs, fetchWorkflowFailureLogs } from '../flow/action';

const { TabPane } = Tabs;
const TABS = ['actionLog', 'failureLog'];
const propTypes = {
  actionLogs: PropTypes.array.isRequired,
  actionLogsPagination: PropTypes.object.isRequired,
  failureLogs: PropTypes.array.isRequired,
  failureLogsPagination: PropTypes.object.isRequired,
  fetchWorkflowActionLogs: PropTypes.func.isRequired,
  fetchWorkflowFailureLogs: PropTypes.func.isRequired,
};

class WorkflowLog extends Component {
  componentDidMount() {
    this.handleTabChange(TABS[0]);
  }

  handleTabChange = key => {
    if (key === TABS[1]) {
      const { failureLogsPagination, fetchWorkflowFailureLogs } = this.props;
      fetchWorkflowFailureLogs(failureLogsPagination.perPage, failureLogsPagination.currentPage);
    } else if (key === TABS[0]) {
      const { actionLogsPagination, fetchWorkflowActionLogs } = this.props;
      fetchWorkflowActionLogs(actionLogsPagination.perPage, actionLogsPagination.currentPage);
    }
  }

  render() {
    const {
      actionLogs,
      actionLogsPagination,
      failureLogs,
      failureLogsPagination,
      fetchWorkflowActionLogs,
      fetchWorkflowFailureLogs
    } = this.props;

    const actionLogColumns = [{
      title: <FormattedMessage id="page.WorkflowList.triggerType" />,
      key: 'op_code',
      dataIndex: 'op_code'
    }, {
      title: <FormattedMessage id="page.WorkflowList.executionDate" />,
      key: 'created_at',
      dataIndex: 'created_at',
      render: text => toTimezone(text, true),
    }, {
      title: <FormattedMessage id="page.WorkflowList.errMsg" />,
      key: 'payload',
      dataIndex: 'payload',
      render: text => (
        (text && text.error) ? text.error : null
      )
    }, {
      title: <FormattedMessage id="page.WorkflowList.workflowCode" />,
      key: 'workflow_rule_code',
      dataIndex: 'workflow_rule_code'
    }, {
      title: <FormattedMessage id="page.WorkflowList.status" />,
      key: 'status',
      dataIndex: 'status'
    }];

    const failureLogColumns = [{
      title: <FormattedMessage id="page.WorkflowList.workflowCode" />,
      key: 'workflow_rule_code',
      dataIndex: 'workflow_rule_code'
    }, {
      title: <FormattedMessage id="page.WorkflowList.executionDate" />,
      key: 'created_at',
      dataIndex: 'created_at',
      render: text => toTimezone(text, true),
    }, {
      title: <FormattedMessage id="page.WorkflowList.errMsg" />,
      key: 'payload',
      dataIndex: 'payload',
      render: text => (
        (text && text.error) ? text.error : null
      )
    }];

    const getPagination = (logPagination, logType) => ({
      defaultCurrent: logPagination.currentPage,
      current: logPagination.currentPage,
      defaultPageSize: logPagination.perPage,
      pageSize: logPagination.perPage,
      total: logPagination.total,
      size: 'small',
      onChange(page, pageSize) {
        if (logType === TABS[0]) {
          fetchWorkflowActionLogs(pageSize, page);
        } else {
          fetchWorkflowFailureLogs(pageSize, page);
        }
      },
    });

    return (
      <Panel
        panelTitle={<FormattedMessage id="page.WorkflowList.executionHistory" />}
        contentClasses="pt-lg pb-lg pl-lg pr-lg"
      >
        <Tabs
          defaultActiveKey={TABS[0]}
          type="card"
          tabBarGutter={0}
          animated
          className="workflow-log-tabs"
          onChange={this.handleTabChange}
        >
          <TabPane
            tab={<FormattedMessage id="page.WorkflowList.actionsLog" />}
            key={TABS[0]}
          >
            <Table
              dataSource={actionLogs}
              columns={actionLogColumns}
              pagination={getPagination(actionLogsPagination, TABS[0])}
              rowKey="id"
            />
          </TabPane>
          <TabPane
            tab={<FormattedMessage id="page.WorkflowList.filterFailures" />}
            key={TABS[1]}
          >
            <Table
              dataSource={failureLogs}
              columns={failureLogColumns}
              pagination={getPagination(failureLogsPagination, TABS[1])}
              rowKey="id"
            />
          </TabPane>
        </Tabs>
      </Panel>
    );
  }
}

const mapStateToProps = ({ setup, global }) => {
  const {
    actionLogs,
    actionLogsPagination,
    failureLogs,
    failureLogsPagination
  } = setup.workFlow.workflowLogs;

  return {
    lang: global.language,
    actionLogs,
    actionLogsPagination,
    failureLogs,
    failureLogsPagination
  };
};

const mapDispatchToProps = {
  fetchWorkflowActionLogs,
  fetchWorkflowFailureLogs,
};

WorkflowLog.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(WorkflowLog);



// WEBPACK FOOTER //
// ./src/views/Setup/WorkflowList/component/workflowLog.js